var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [_vm._v("Need financing to support your business growth?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n    Asoko provides opportunities to companies seeking solutions to their financial, development, sustainability, and growth needs.\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "action-wrap" }, [
        _c(
          "a",
          {
            staticClass: "cta-button",
            class: _vm.colorMode === "light" ? "medium-button" : "",
            on: { click: _vm.openLink },
          },
          [_vm._v("Opportunities for African Businesses")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }